import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BRIEF_SCRIPTING_QUERY_KEY } from "@entities/brief/lib/constants";
import { IUploadScripting } from "@shared/lib/types/briefCampains";
import { BriefConfigService } from "../../services/briefConfigService";

export function useUploadScripting(scriptId: string) {
  const {
    mutate: uploadScripting,
    isLoading: isUploading,
    isSuccess: isUploaded,
  } = useMutation({
    mutationFn: (payload: IUploadScripting) =>
      BriefConfigService.uploadScripting(payload).catch(async (err) => {
        const responseBody = await err.response?.json?.();

        if (responseBody?.msg) ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({ queryKey: BRIEF_SCRIPTING_QUERY_KEY(scriptId) });
    },
  });

  return { uploadScripting, isUploading, isUploaded };
}
